import { render } from "./TheProgressBar.vue?vue&type=template&id=2674cc90&scoped=true"
import script from "./TheProgressBar.vue?vue&type=script&lang=js"
export * from "./TheProgressBar.vue?vue&type=script&lang=js"

import "./TheProgressBar.vue?vue&type=style&index=0&id=2674cc90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2674cc90"]])

export default __exports__